'use client';

import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
	useEffect(() => {
		console.error('GLOBAL ERROR:', error);
		console.error('STACK:', error.stack);
	}, [error]);

	return (
		<html lang="pt-BR">
			<body>
				<h2>Erro</h2>
				<pre>{String(error.message)}</pre>
			</body>
		</html>
	);
}
